module.exports = __webpack_public_path__ + "static/media/q01.ec54ab4c.mp3";